import { z } from 'zod';

export const schema = z.object({
  email: z
    .string()
    .min(1, { message: 'メールアドレスを入力してください。' })
    .email({ message: '正しいメールアドレスを入力してください。' }),
  lastName: z
    .string()
    .min(1, { message: '姓を入力してください。' })
    .max(50, { message: '姓は50文字以内で入力してください。' }),
  firstName: z
    .string()
    .min(1, { message: '名を入力してください。' })
    .max(50, { message: '名は50文字以内で入力してください。' }),
  password: z
    .string()
    .min(6, { message: 'パスワードは6文字以上で入力してください。' })
    .regex(/^[a-zA-Z0-9!-/:-@¥[-`{-~]+$/, {
      message: 'パスワードは半角の英数字・記号で入力してください。',
    }),
  approveTermsOfUse: z.boolean().refine(val => val, {
    message: '会員規約に同意してください。',
  }),
});

export type Schema = z.infer<typeof schema>;
